<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<div #threatDiv id="threat-activity-div" class="threat-activity-wrapper" >
  <app-threat-activity
    [timeInterval]="timeInterval"
    [selectedOrgId]="selectedOrgId$ | async"
    [heightStyle]="threatDiv.offsetHeight">
  </app-threat-activity>
</div>
